import { computed, type ComputedRef } from 'vue';
import { appConfig, features, useAuthSessionStore, useFeatureFlag } from '@peanuds/app-shell';

export const useBatchPaymentsEnabled = (): ComputedRef<boolean> => {
  const session = useAuthSessionStore();
  const enabled = useFeatureFlag(features.batchPayments);
  const clientId = appConfig.VITE_BATCH_PAYMENTS_CLIENT_ID?.trim();

  return computed(() => (Boolean(clientId) && session.ifClientId === clientId) || enabled.value);
};
